import { useEffect } from 'react';
import { useSettingsStore } from '@/stores/settings-store';

/**
 * Mirror the `ui.fontFamily` and `ui.fontSize` settings to CSS custom
 * properties on the document root so global stylesheet rules (see
 * `styles/globals.css`) can pick them up for form inputs.
 *
 * Keep this small — we intentionally only style `input`, `textarea`, and
 * `select` with these vars. Body text / buttons / labels stay on the
 * existing Tailwind classes to avoid accidental layout drift across the
 * app when a user cranks the font size up.
 */
export function useUIFontVars(): void {
  const fontFamily = useSettingsStore((s) => s.get('ui.fontFamily', 'system-ui, -apple-system, sans-serif'));
  const fontSize = useSettingsStore((s) => s.getNumber('ui.fontSize', 13));

  useEffect(() => {
    const root = document.documentElement;
    root.style.setProperty('--dbgo-ui-font-family', fontFamily);
    root.style.setProperty('--dbgo-ui-font-size', `${fontSize}px`);
  }, [fontFamily, fontSize]);
}
